import * as React from 'react';
import { inputFormatters } from 'ui-common';
import { MoneyInput as ConsumerMoneyInput } from 'consumer-components';
import InputContainer, { InputContainerProps } from '../InputContainer/InputContainer';
import { getIdFromName } from '../inputUtils';

class MoneyInput extends React.Component<InputProps, {}> {
  private inputProps: DirectInputProps;
  private inputContainerProps: InputContainerProps;

  render() {
    const { input, placeholder, label, meta } = this.props;
    this.inputProps = {
      ...input,
      id: getIdFromName(input.name),
      placeholder,
      type: 'text',
    };

    this.inputContainerProps = {
      label: label || '',
      prefix: '$',
      identifier: input.name,
      name: input.name,
      error: meta.touched && meta.error,
    };

    return (
      <div className="MoneyInput">
        <InputContainer {...this.inputContainerProps}>
          <ConsumerMoneyInput
            {...this.inputProps}
            normalize={inputFormatters.MONEY_CENTS.normalize}
            format={inputFormatters.MONEY_CENTS.format}
          />
        </InputContainer>
      </div>
    );
  }
}

export const MoneyInputConfig = {
  component: MoneyInput,
  normalize: inputFormatters.MONEY_CENTS.normalize,
};

export default MoneyInput;
